// Defines the viewport width at which the sub-packages should be stacked on
// top of the table of individual styles as a factor of the number of weights
// and whether or not there are any sub-packages.
export const packagesStackedQuery = `(max-width: 1020px)`;

// Defines the cell size.
export const cellSize = `80px`;

// Defines the cell size.
export const doubleCellSize = `160px`;
